import React, { useEffect } from 'react';
import PackageComponent from '../components/PackageComponent';
import premiumImage from '../assets/images/Paket1.png'; 

const UmrahPackage = () => {
  useEffect(() => {
    document.title = 'Umrah Paket – Umrah Bröderna';
  }, []);

  return (
    <div>
      <PackageComponent
        title="Våra Paket"
        heading="Våra Paket"
        description={
            <>
              Alla våra Umrah-paket erbjuder en komplett andlig resa med boende nära Haram, bekväma flyg, guidning och 24/7 support.
              <br />
              <small>Sommar, Höst, Vinter, Ramadan - Alla paket innehåller samma förmåner.</small>
              <br />
              <small>Antal dagar och pris kan variera beroende på årstiden.</small>
              <br />
              <small>Vi reserverar oss för felskrivning.</small>
              <br />
              
              <br />
              <strong>Standard-paketet:</strong> Erbjuder ett färdigt 4-bäddsrum till ett förmånligt pris.
              <br />
              <strong>Premium-paketet:</strong> Ger dig möjligheten att välja rumstyp (2, 3 eller 4-bäddsrum) och själv välja vem du vill dela rum med.
              <br />
            </>
          }
          
        rawDescription="Båda våra Umrah-paket erbjuder en komplett andlig resa med boende nära Haram, bekväma flyg, guidning och 24/7 support. Premium-paketet ger dig möjlighet att välja rumstyp (2 eller 3 bäddsrum) och själv välja vem du vill dela rum med. Standard-paketet erbjuder ett färdigt 4-bäddsrum till ett förmånligt pris."
        image={premiumImage}
        price="Från 19975 SEK"
        details={[
          { label: "Vistelse", value: "minst 8 Dagar" },
          { label: "Visum", value: "Vi sköter visumansökan för alla" },
          { label: "Flyg", value: "Tur & Retur + baggage" },
          { label: "Transport", value: "Flygplatstransport till & från hotell samt lokal transport (Tur & Retur)" },
          { label: "Boende", value: "Gångavstånd till Haram i både Mecka & Medina" },
          { label: "Rawdah Al-Jannah & Salam", value: "Vi hjälper er boka plats för att be i Rawdah samt hälsa på Profetens (S.A.W) grav samt Abu Bakr (R.A) och Umar (R.A)" },
          { label: "Ziyarat/Guidade turer (Mecka)", value: "Jannat-ul-Mualla, Masjid Jin, , Masjid Aisha, Mina, Arafat, Muzdalifah, Cave of Hira. m.m." },
          { label: "Ziyarat/Guidade turer (Medina)", value: "Hamza’s grav (RA), Uhud Berget, Masjid Ejabah, Jannatul Baqi, Masjid Abu Bakr (RA), Masjid Ghamama, Masjid Quba, Masjid Qiblatayn, Masjid Jumuah. m.m." },
          { label: "Support", value: "Tillgängligt 24/7 för våra pilgrimer" },
          { label: "Extras", value: "Välkomstpaket (Ihram, ZamZam & dadlar, så långt lagret räcker)" }
        ]}
      />
    </div>
  );
};

export default UmrahPackage;
